export const mutliplyEmpty = (number, number2) => {
  return (parseFloat(number) || 0) * number2;
};